<template>
  <core-view>
    <core-data-pagination
      ref="dataPagination"
      :loading="loading"
      :load-handler="$_load"
      :options.sync="options"
    >
      <template #card-skeleton-loader="{ attrs, on }">
        <app-card-frota-skeleton v-bind="attrs" v-on="on" actions />
      </template>

      <template #card="{ item, attrs, on }">
        <app-card-frota actions
          id='CARD-DETALHE'
          v-bind="attrs"
          v-on="on"
          :value="item"
          @click="$_onClickItem($event, item)" >
        </app-card-frota>
      </template>
    </core-data-pagination>
  </core-view>
</template>

<script>

import { GENERIC_QUERIES, FROTA_QUERIES } from '@/constants/QUERY_FILTERS';

import errorHandler from '@/utils/error-handler';
import deepEquals from '@/utils/deep-equals';

import RemoveItemDialog from '@/events/RemoveItemDialog';

import {
  getNumberQueryValue, getQueryValue, getSortQueryValue, setQueryValue, setSortQueryValue,
} from '@/services/query-string';

import CoreView from '@/components/core/view/Index.vue';
import CoreDataPagination from '@/components/core/new-data-pagination/Index.vue';

import AppCardFrotaSkeleton from '@/components/app/card/frota/Skeleton.vue';
import AppCardFrota from '@/components/app/card/frota/Index.vue';
import { FROTA_STORAGE } from '@/constants/STORAGE';

import db from '@/plugins/dexie';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default {
  name: 'ViewRecebimento',

  components: {
    CoreView,
    CoreDataPagination,
    AppCardFrotaSkeleton,
    AppCardFrota,
  },

  data() {
    if (this.$route.params.clearSession) {
      sessionStorage.removeItem(FROTA_STORAGE.placa);
      sessionStorage.removeItem(FROTA_STORAGE.tipo);
    }

    return {
      loading: false,
      newRecebimentoRoute: {
        params: { recebimentoId: 'new' },
      },

      filters: {
        placa: getSessionStorage(FROTA_STORAGE.placa),
        tipo: getSessionStorage(FROTA_STORAGE.tipo),
      },

      options: {
        page: getSessionStorage(FROTA_STORAGE.page, 1),
        itemsPerPage: 10,
        sortBy: ['recnumerocontrolerecbto'],
        sortDesc: [true],
      },
    };
  },

  methods: {

    async $_load() {
      this.loading = true;
      let possuiWhere = false;

      try {
        const where = {};
        if (String(this.filters.tipo) !== 'null') {
          possuiWhere = true;
          where.veitipomaquinario = this.filters.tipo;
        }
        if (String(this.filters.placa) !== 'null') {
          possuiWhere = true;
          where.veiplaca = this.filters.placa;
        }
        console.log(this.filters, where);
        if (possuiWhere) {
          console.log(where);
          return await db.veiculo.where(where).toArray().then((item) => ({ data: item }));
        }
        return await db.veiculo.toArray().then((item) => ({ data: item }));
      } catch (err) {
        errorHandler.call(this, err);
        return { data: [], total: 0 };
      } finally {
        this.loading = false;
      }
    },

    async $_onClickItem() {
      // this.$router.push({
      //   mouseEvent,
      //   name: ROUTE_RECEBIMENTO_ID.name,
      //   params: { recebimentoId: item.id },
      // });
    },

    $_onClickRemoveItem(mouseEvent, item) {
      RemoveItemDialog.emit({
        message: this.$t('messages.removeUserMessage'),
        alertMessage: this.$t('messages.removeUserAllertMessage'),
        confirmText: item.id,
        onConfirmHandler: () => new Promise((resolve) => {
          setTimeout(() => {
            resolve(false);
          }, 1000 * 5);
        }),
        onCancelHandler() {},
      });
    },
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.options.page = getNumberQueryValue(GENERIC_QUERIES.page, this.options.page);

        const defaultSort = `${this.options.sortDesc[0] ? '+' : '-'}${this.options.sortBy[0]}`;
        const { field, order } = getSortQueryValue(GENERIC_QUERIES.sort, defaultSort);
        this.options.sortBy[0] = field;
        this.options.sortDesc[0] = order;

        const filters = {
          search: getQueryValue(GENERIC_QUERIES.search, null),
          placa: getQueryValue(
            FROTA_QUERIES.placa,
            this.filters.placa,
          ),
          tipo: getQueryValue(
            FROTA_QUERIES.tipo,
            this.filters.tipo,
          ),
        };

        if (!deepEquals(this.filters, filters)) {
          this.filters.placa = filters.placa;
          this.filters.tipo = filters.tipo;
          if (this.$refs.dataPagination) {
            this.$refs.dataPagination.reload();
          }
        }
      },
    },

    options: {
      deep: true,
      handler() {
        setQueryValue(GENERIC_QUERIES.page, this.options.page);
        setSortQueryValue(GENERIC_QUERIES.sort, this.options.sortBy[0], this.options.sortDesc[0]);
        setQueryValue(FROTA_QUERIES.placa, this.filters.placa);
        setQueryValue(FROTA_QUERIES.tipo, this.filters.tipo);
      },
    },
  },
};
</script>
<style>
#resumo{
  float: right;
}
</style>
